module.exports = __webpack_public_path__ + "img/tima_bg1.e91a0182.png";